import styled from "styled-components";

const MaxWidthContainer = styled.div`
  position: relative;
  width: 100%;
`;

export default MaxWidthContainer;
